import { Link } from "react-router-dom";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const LAURINE_PHOTO = "https://customer-assets.emergentagent.com/job_precision-amour/artifacts/vid4snop_IMG_2975.png";

export default function About() {
  useScrollReveal();

  return (
    <main className="page-fade" data-testid="about-page" style={{ paddingTop: "160px" }}>

      {/* Header */}
      <section style={{ padding: "40px 24px 80px", backgroundColor: "#F7F3EA" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <p style={{ fontSize: "10px", letterSpacing: "5px", textTransform: "uppercase", color: "rgba(61,22,2,0.4)", marginBottom: "20px" }}>
            À Propos
          </p>
          <h1 style={{
            fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
            fontSize: "clamp(2.5rem, 6vw, 5rem)",
            fontWeight: 300, color: "#3D1602",
            letterSpacing: "-0.02em", lineHeight: 1.1, marginBottom: "0",
          }}>
            Je suis Laurine,<br />fondatrice d'Ellaa Wedding.
          </h1>
        </div>
      </section>

      {/* Photo + texte principal */}
      <section style={{ padding: "0 24px 100px", backgroundColor: "#F7F3EA" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "80px", alignItems: "start" }}
            className="lg:grid-cols-2"
          >
            {/* Photo */}
            <div className="scroll-reveal">
              <img
                src={LAURINE_PHOTO}
                alt="Laurine, fondatrice d'ELLAA WEDDING"
                style={{ width: "100%", height: "680px", objectFit: "cover", objectPosition: "center top", display: "block" }}
              />
              <div style={{ paddingTop: "20px" }}>
                <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontSize: "22px", fontWeight: 300, color: "#3D1602", margin: 0 }}>Laurine</p>
                <p style={{ fontSize: "10px", letterSpacing: "4px", textTransform: "uppercase", color: "#6D5E56", marginTop: "6px" }}>Fondatrice & Wedding Planner</p>
              </div>
            </div>

            {/* Texte */}
            <div className="scroll-reveal delay-1">

              <div style={{ marginBottom: "40px" }}>
                <p style={{ fontSize: "15px", lineHeight: "2", color: "#6D5E56", fontWeight: 300, marginBottom: "16px" }}>
                  Avant d'être wedding planner, j'ai été Responsable RH.
                </p>
                <p style={{ fontSize: "15px", lineHeight: "2", color: "#6D5E56", fontWeight: 300, marginBottom: "16px" }}>
                  Un métier qui m'a appris la rigueur, l'organisation, l'anticipation, la gestion des imprévus… et surtout la compréhension profonde de l'humain.
                </p>
                <p style={{ fontSize: "15px", lineHeight: "2", color: "#6D5E56", fontWeight: 300, marginBottom: "16px" }}>
                  J'ai toujours aimé structurer, planifier, orchestrer. J'aime quand tout est maîtrisé, quand chaque détail a du sens, quand rien n'est laissé au hasard.
                </p>
                <p style={{ fontSize: "15px", lineHeight: "2", color: "#6D5E56", fontWeight: 300 }}>
                  Mais ce qui m'anime par-dessus tout, c'est l'amour.
                </p>
              </div>

              {/* Citation / bloc fort */}
              <div style={{ borderLeft: "2px solid #E9DCC4", paddingLeft: "28px", marginBottom: "40px" }}>
                <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic", fontSize: "19px", color: "#3D1602", lineHeight: 1.7, margin: 0 }}>
                  Il y a deux ans, j'ai moi-même vécu cette aventure. Un mariage à mon image. Élégant, vibrant, profondément symbolique.
                </p>
              </div>

              <div style={{ marginBottom: "40px" }}>
                <p style={{ fontSize: "15px", lineHeight: "2", color: "#6D5E56", fontWeight: 300, marginBottom: "16px" }}>
                  J'ai choisi d'être accompagnée par une wedding planner, parce que je savais que je voulais vivre pleinement chaque instant sans porter la charge mentale de l'organisation.
                </p>
                <p style={{ fontSize: "15px", lineHeight: "2", color: "#6D5E56", fontWeight: 300, marginBottom: "16px" }}>
                  Deux ans plus tard, on parle encore de ce mariage. De l'émotion. De l'ambiance. De l'énergie.
                </p>
                <p style={{ fontSize: "15px", lineHeight: "2", color: "#6D5E56", fontWeight: 300 }}>
                  Ce jour-là a confirmé ce que je ressentais depuis toujours : <strong style={{ color: "#3D1602", fontWeight: 400 }}>un mariage bien orchestré ne s'oublie pas.</strong>
                </p>
              </div>

              <div className="scroll-reveal delay-2">
                <Link to="/contact" className="btn-outline-dark" data-testid="about-contact-cta">
                  Travaillons ensemble
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Origines & sensibilité */}
      <section style={{ padding: "100px 24px", backgroundColor: "#EBE6DB", borderTop: "1px solid rgba(61,22,2,0.07)" }}>
        <div style={{ maxWidth: "860px", margin: "0 auto" }}>
          <p className="scroll-reveal" style={{ fontSize: "10px", letterSpacing: "5px", textTransform: "uppercase", color: "rgba(61,22,2,0.4)", marginBottom: "32px" }}>
            Mes origines
          </p>
          <div className="scroll-reveal delay-1" style={{ marginBottom: "40px" }}>
            <p style={{ fontSize: "15px", lineHeight: "2", color: "#6D5E56", fontWeight: 300, marginBottom: "16px" }}>
              Je suis issue d'un couple mixte, et d'une famille aux origines multiples. J'ai grandi avec la richesse des cultures, la force des traditions, la beauté des mélanges.
            </p>
            <p style={{ fontSize: "15px", lineHeight: "2", color: "#6D5E56", fontWeight: 300, marginBottom: "24px" }}>
              Je comprends ce que cela représente :
            </p>
            <ul style={{ listStyle: "none", padding: 0, margin: "0 0 24px" }}>
              {[
                "vouloir honorer deux histoires",
                "respecter deux héritages",
                "créer une célébration qui rassemble sans effacer",
              ].map((item, i) => (
                <li key={i} style={{ fontSize: "15px", lineHeight: "2", color: "#6D5E56", fontWeight: 300, display: "flex", gap: "12px", alignItems: "flex-start", marginBottom: "4px" }}>
                  <span style={{ color: "#3D1602", flexShrink: 0 }}>–</span>{item}
                </li>
              ))}
            </ul>
            <p style={{ fontSize: "15px", lineHeight: "2", color: "#6D5E56", fontWeight: 300 }}>
              C'est cette sensibilité qui m'a naturellement menée vers les mariages afro-caribéens et mixtes haut de gamme.
            </p>
          </div>

          {/* Double identité */}
          <div className="scroll-reveal delay-2" style={{ borderLeft: "2px solid #E9DCC4", paddingLeft: "28px", marginBottom: "48px" }}>
            <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic", fontSize: "19px", color: "#3D1602", lineHeight: 1.7, margin: 0 }}>
              Ellaa Wedding est né de cette double identité : la rigueur professionnelle d'une responsable RH et la sensibilité d'une femme passionnée par l'amour, les cultures et les célébrations d'exception.
            </p>
          </div>
        </div>
      </section>

      {/* Mon rôle */}
      <section style={{ padding: "100px 24px", backgroundColor: "#F7F3EA" }}>
        <div style={{ maxWidth: "860px", margin: "0 auto" }}>
          <p className="scroll-reveal" style={{ fontSize: "10px", letterSpacing: "5px", textTransform: "uppercase", color: "rgba(61,22,2,0.4)", marginBottom: "32px" }}>
            Mon rôle
          </p>
          <h2 className="scroll-reveal delay-1" style={{
            fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
            fontSize: "clamp(1.8rem, 3vw, 2.8rem)",
            fontWeight: 300, color: "#3D1602",
            lineHeight: 1.3, marginBottom: "40px",
          }}>
            Vous permettre de vivre votre mariage, sans stress, sans dispersion, avec maîtrise et élégance.
          </h2>

          <div className="scroll-reveal delay-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0", marginBottom: "48px" }} className="grid grid-cols-2 md:grid-cols-4 scroll-reveal delay-2">
            {["Je structure.", "J'anticipe.", "Je coordonne.", "Je sublime."].map((v, i) => (
              <div key={i} style={{ padding: "28px 24px", borderTop: "1px solid rgba(61,22,2,0.1)", borderRight: i < 3 ? "1px solid rgba(61,22,2,0.1)" : "none" }}>
                <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontSize: "20px", fontWeight: 300, color: "#3D1602", margin: 0 }}>{v}</p>
              </div>
            ))}
          </div>

          <div className="scroll-reveal delay-3" style={{ borderLeft: "2px solid #E9DCC4", paddingLeft: "28px", marginBottom: "48px" }}>
            <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic", fontSize: "19px", color: "#3D1602", lineHeight: 1.7, margin: 0 }}>
              Parce qu'un mariage n'est pas qu'un événement. C'est un héritage émotionnel. Et je crois profondément qu'il mérite d'être orchestré avec exigence, cœur et précision.
            </p>
          </div>

          <div className="scroll-reveal delay-3">
            <a href="https://calendly.com/ellaa-wedding/30min" target="_blank" rel="noopener noreferrer"
              data-testid="about-cta-btn" className="btn-primary"
            >
              Réserver mon appel découverte
            </a>
          </div>
        </div>
      </section>

    </main>
  );
}
